var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91659 11.0003H5.86221C6.66162 11.0003 7.39241 11.452 7.74992 12.167C8.10742 12.882 8.83822 13.3337 9.63763 13.3337H16.3622C17.1616 13.3337 17.8924 12.882 18.2499 12.167C18.6074 11.452 19.3382 11.0003 20.1376 11.0003H24.0833M9.46091 1.66699H16.5389C17.7953 1.66699 18.4235 1.66699 18.978 1.85828C19.4685 2.02745 19.9152 2.30352 20.2858 2.66653C20.7049 3.07702 20.9859 3.63889 21.5477 4.7626L24.0754 9.81791C24.2959 10.2589 24.4061 10.4794 24.4839 10.7105C24.5529 10.9157 24.6028 11.1269 24.6328 11.3413C24.6666 11.5828 24.6666 11.8293 24.6666 12.3223V14.7337C24.6666 16.6938 24.6666 17.6739 24.2851 18.4226C23.9495 19.0812 23.4141 19.6166 22.7556 19.9522C22.0069 20.3337 21.0268 20.3337 19.0666 20.3337H6.93325C4.97307 20.3337 3.99298 20.3337 3.24429 19.9522C2.58572 19.6166 2.05029 19.0812 1.71473 18.4226C1.33325 17.6739 1.33325 16.6938 1.33325 14.7337V12.3223C1.33325 11.8293 1.33325 11.5828 1.36706 11.3413C1.39708 11.1269 1.44693 10.9157 1.51598 10.7105C1.59372 10.4794 1.70397 10.2589 1.92446 9.81791L4.45212 4.7626C5.01397 3.63888 5.2949 3.07702 5.71402 2.66653C6.08465 2.30352 6.53135 2.02745 7.02179 1.85828C7.57638 1.66699 8.20456 1.66699 9.46091 1.66699Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.90a24125f0997079796d009ade48e72a.svg";
export { ForwardRef as ReactComponent };